import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from "@angular/forms";
import {CustomValidationService} from "../services/custom-validation.service";

@Directive({
  selector: '[app-onlyText]',
  providers: [{ provide: NG_VALIDATORS, useExisting: TextPatternDirective, multi: true }]
})
export class TextPatternDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.textPatternValidator()(control);
  }

}
